module.exports = __webpack_public_path__ + "static/media/QRcodeSerios-playStore.e169e06d.svg";